module.exports = require("@mui/icons-material/Autorenew");